var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9,
    height: 11,
    viewBox: "0 0 9 11",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.20042 6.20629L1.74995 9.94905C1.20253 10.2664 0.5 9.88214 0.5 9.24247V1.75696C0.5 1.1183 1.20151 0.733076 1.74995 1.05139L8.20042 4.79415C8.32494 4.86523 8.42846 4.96799 8.50045 5.09199C8.57245 5.21599 8.61037 5.35683 8.61037 5.50022C8.61037 5.64361 8.57245 5.78445 8.50045 5.90845C8.42846 6.03245 8.32494 6.13521 8.20042 6.20629Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.6f21688ac4aaac3f111176fdd178322d.svg";
export { ForwardRef as ReactComponent };